import React, { useEffect, useMemo } from 'react'
import { useAppDispatch } from '../../store/hooks'

// Actions
import * as teamActions from '../../metrics_server/teams/actions'

// Hooks
import { useTeams } from '../../metrics_server/teams/hooks'
import { usePlayers } from '../../metrics_server/players/hooks'
import { useSessions } from '../../metrics_server/sessions/hooks'

// Functions
import { sortArrayOfObjectsByKey } from '../../utils/helpers'
import { getPlayersByTeamId } from '../../metrics_server/players/functions'

//TeamsContainer - Higher Order Component for teams management

export const TeamsContainer = (View) => {
  return (props) => {
    // Redux Store
    const dispatch = useAppDispatch()
    const teams = useTeams()
    const players = usePlayers()
    const sessions = useSessions()

    const { selectedTeam, items } = teams

    // Fetch team players data
    useEffect(() => {
      if (selectedTeam) {
        dispatch(teamActions.getTeamPlayers(selectedTeam))
      }
    }, [selectedTeam, dispatch])

    // Memoized data
    const teamData = useMemo(() => {
      const team = items[selectedTeam]
      const teamsArray = Object.values(items)

      let teamPlayers = []
      if (team) {
        teamPlayers = getPlayersByTeamId(players, team.id)
        teamPlayers = sortArrayOfObjectsByKey(teamPlayers, 'lastName')
      }

      return {
        team,
        teamsArray,
        teamPlayers
      }
    }, [items, selectedTeam, players])

    // Player actions

    return (
      <View
        {...props}
        teamsArray={teamData.teamsArray}
        teamPlayers={teamData.teamPlayers}
        sessions={sessions}
        getTeamPlayers={(teamId) =>
          dispatch(teamActions.getTeamPlayers(teamId))
        }
      />
    )
  }
}
